export const buildPriceBody = (company) => {
    return {
        price_mt: document.getElementById('product_price_price_mt').value,
        price_kg: document.getElementById('product_price_price_kg').value,
        company
    }
}

export const validateProductPriceBody = (body) => {

    if(body.price_mt === null || body.price_mt === ''){
        throw new Error('Precio vacío');
    }

    if(isNaN(body.price_mt.replaceAll(" ","") || body.price_mt.includes('-'))){
        throw new Error('Precio no es valor numérico positivo');
    }

    if(body.price_mt < 0){
        throw new Error('Precio no es valor numérico positivo ');
    }

    if(body.price_kg === null || body.price_kg === ''){
        throw new Error('Precio vacío');
    }

    if(isNaN(body.price_kg.replaceAll(" ","") || body.price_kg.includes('-'))){
        throw new Error('Precio no es valor numérico positivo');
    }

    if(body.price_kg < 0){
        throw new Error('Precio no es valor numérico positivo ');
    }

    if((body.price_mt === 0 || body.price_mt === '0') && (body.price_kg === 0 || body.price_kg === '0')){
        throw new Error('Los dos precios son cero');
    }

    if(body.company === null || body.company === ''){
        throw new Error('Empresa vacía');
    }
}